import React, { useRef, useEffect } from 'react';
import { Fireworks } from 'fireworks-js';
import catsHug from '../assets/Q12/cats_hug.jpg';

const FIREWORKS_OPTIONS = {
  autoresize: true,
  opacity: 0.5,
  acceleration: 1,
  friction: 0.97,
  gravity: 1.5,
  particles: 90,
  traceLength: 3,
  traceSpeed: 10,
  explosion: 5,
  intensity: 28,
  flickering: 50,
  lineStyle: 'square',
  hue: { min: 200, max: 360 },
  delay: { min: 30, max: 60 },
  lineWidth: {
    explosion: { min: 2, max: 4 },
    trace: { min: 1, max: 6 },
  },
  brightness: { min: 50, max: 80 },
  decay: { min: 0.015, max: 0.03 },
  mouse: { click: false, move: false },
};

function LastPanel({ onNavigate }) {
  const containerRef = useRef(null);
  const fireworksRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    fireworksRef.current = new Fireworks(container, FIREWORKS_OPTIONS);
    fireworksRef.current.start();

    return () => {
      if (fireworksRef.current) {
        fireworksRef.current.stop(true);
      }
    };
  }, []);

  const handleAgainClick = () => {
    onNavigate?.('StartUp');
  };

  return (
    <div className="dashboard lastpanel">
      <div
        ref={containerRef}
        className="lastpanel__fireworks"
        aria-hidden="true"
      />
      <div className="home__center startup__stack lastpanel__stack">
        <h1 className="startup__title lastpanel__title">
          <span className="startup__line startup__line--small word-wrap">YAY</span>
        </h1>
        <img src={catsHug} alt="" className="lastpanel__img" />
        <button
          type="button"
          className="dashboard__button dashboard__button--primary home__button"
          onClick={handleAgainClick}
        >
          Again! Again! Again!
        </button>
      </div>
    </div>
  );
}

export default LastPanel;
